import {
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent,
    type ChartConfig,
} from "@/components/ui/chart";
import { cn } from "@/lib/utils";
import React from "react";
import { Label, Pie, PieChart } from "recharts";

export type ChartData = {
    key: string;
    data: number | string;
    fill?: string;
};

export type StandardPieChartProps = {
    config: ChartConfig;
    data: ChartData[];
    center: string;
    centerLabel: string;
    className?: string;
};

export const StandardPieChart = ({
    config,
    data,
    center,
    centerLabel,
    className,
}: StandardPieChartProps): JSX.Element => {
    const dataWithFill = data.map((d) => ({
        ...d,
        fill: d.fill ?? `var(--color-${d.key})`,
    }));

    return (
        <ChartContainer config={config} className={cn("h-48", className)}>
            <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                <ChartLegend
                    content={<ChartLegendContent nameKey="key" verticalAlign="bottom" />}
                    layout="vertical"
                    verticalAlign="middle"
                    align="right"
                />
                <Pie
                    data={dataWithFill}
                    dataKey="data"
                    nameKey="key"
                    innerRadius={50}
                    outerRadius={80}
                    strokeWidth={5}
                >
                    <Label position="center" dy={-4} className="fill-foreground text-3xl font-bold">
                        {center}
                    </Label>
                    <Label position="center" dy={20} className="fill-muted-foreground">
                        {centerLabel}
                    </Label>
                </Pie>
            </PieChart>
        </ChartContainer>
    );
};
